import { Certificate, IssuedCertificate } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * Provides CRUD access for authenticated user to access a his/her own Certificates
 */
export class Certificates extends CrudApiBase<Certificate, never> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/accounts/certificate";

  constructor(ajax: Ajax) {
    super(ajax);
  }

  /**
   * Returns an empty certificate without any values.
   */
  public getBlank(): Certificate {
    return {};
  }

  /**
   * Issues a new certificate for the account and provides the certificate in PEM format.
   * For this method, also the Certificate Signing Request (CSR) may be passed in the certificate Text field.
   * @param certificate A certificate object containing title for the new certificate.
   * You may also pass the Certificate Signing Request (CSR) in the Password field. In this case the private key is not returned by the method.
   * @returns PEM files in zip: crt (public key / certificate), key (private key) and (both in one pem file).
   */
  public issuePemCertificate(certificate: Certificate): Promise<IssuedCertificate> {
    return this.ajax.postJSON(this.getUrlWithOptions(this.baseUrl + "/pem", undefined), certificate);
  }

}
